import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import standardServiceStyles from "../StandardStyles";
import { selectServiceTypes } from "../../../../config/redux/configurationsSlice";
import { fetchPOSDetailsByPOSNo } from "../../../CreatePOS/redux/posSlice";
import { fetchSlotsInformationByServiceType, resetSlotsInformation, sendConfigurationForApproval } from "../../redux/templateSlotsSlice";
import { ALERT_TYPES, APP_ROUTES, TEXT_CONSTANT } from "../../../../config/constants";
import CustomAlert from "../../../common/CustomAlert/CustomAlert";
import { check_if_slot_obj_contains_sub_set } from "../../../../utils/ApplicationUtils";
import RenderFooterButtons from "./common/RenderFooterButtons";
import PageTitle from "../../../common/PageTitle/PageTitle";
import OverlayLoader from "../../../common/Loader/OverlayLoader";
import RenderConfigurationSlotsAccordion from "./common/RenderConfigurationSlotsAccordion";
import {
  handle_save_configuration_handler,
  updateD_handle_individual_slot_field_change,
  updateD_make_slot_editable,
  _validate_send_for_approval_form,
  add_new_template_slot_util,
  delete_template_slot_util,
  bulk_update_slot_changes_util,
  validate_generator_form_before_bulk_update,
} from "./common/Utils/NewStandardRequestUtils";
import { fetchPendingApprovalRequest } from "../../../ApprovalRequest/Redux/ApprovalRequestSlice";
import BulkUpdateSummaryDetailsAndConfirmationPopUp from "../Common/BulkUpdateSummaryDetailsAndConfirmationPopUp";
import { isArrayValid, isEmptyOrNull, isNonEmptyObject } from "../../../../utils/DataUtils";

interface NewStandardRequestInterface {
  serviceTypeId: any;
  serviceTypeName: any;
}

const NewStandardRequest = (props: NewStandardRequestInterface) => {
  const { serviceTypeId, serviceTypeName } = props;

  const { posNo, zoneId }: any = useParams();
  const dateObject = {
    activationDate: "",
    activationDatelabel: "",
    isDateValid: false,
    data_present_obj: {
      requestId: "",
      requester: "",
    },
  }

  const classes: any = standardServiceStyles();
  const navigate = useNavigate();
  const appDispatch = useDispatch();
  const dispatch = useDispatch();

  const serviceTypes = useSelector(selectServiceTypes);
  const { posDetails, loading: fetchingDetails, fetching: fetchingPosDetails } = useSelector((state: any) => state.pos);
  const { fetchingSlots, standard } = useSelector((state: any) => state.slots);
  const { currentCountry: { countryId } } = useSelector((state: any) => state.appConfig);

  const [loading, setLoading] = useState(false);
  const [configTab, setConfigTab] = useState({} as any);
  const [originalConfigTab, setOriginalConfigTab] = useState({} as any);
  const [stateObj, setStateObj] = useState({
    loading: false,
    // Bulk Update
    openBulkUpdateConfirmationPopUp: false,
    generatorFormIndex: "",
    configuredDays: [],
    currentBulkUpdateConfigurationSummary: {},
    selctedDays: [],
    currentDay: "",
    configurationBulkUpdatedObj: {
      isConfigurationBulkUpdated: false,
      bulkUpdatedDays: [] as any,
    },
  });

  const designStandardConfigurationsHandler = (slots: any) => {
    if (!isEmptyOrNull(zoneId)) {
      const new_config_tabs = handle_save_configuration_handler(slots, zoneId);
      setOriginalConfigTab(new_config_tabs);
      setConfigTab(new_config_tabs);
      setStateObj({
        ...stateObj,
        loading: false,
        configurationBulkUpdatedObj: {
          isConfigurationBulkUpdated: false,
          bulkUpdatedDays: [],
        },
      });
    }
  };

  const handleIndividualSlotFieldsChange = (event: any, generatorFormIndex: any, slot_index: any) => {
    if (!isEmptyOrNull(event?.target)) {
      const { name, value } = event.target;
      let new_config_tab = updateD_handle_individual_slot_field_change(configTab, generatorFormIndex, slot_index, name, value);
      setConfigTab(new_config_tab);
    }
  };

  const makeSlotEditable = (generatorFormIndex: any, slot_index: any) => {
    if (!isEmptyOrNull(generatorFormIndex) && generatorFormIndex >= 0 && !isEmptyOrNull(slot_index) && slot_index >= 0) {
      let new_config_tab = updateD_make_slot_editable(configTab, generatorFormIndex, slot_index);
      setConfigTab(new_config_tab);
    }
  };

  const call_send_for_approval = async (payload_Object: any) => {
    const { payload }: any = await appDispatch(sendConfigurationForApproval(payload_Object));
    if (payload?.response?.data === "success") {
      CustomAlert(ALERT_TYPES.SUCCESS, `Configuration sent for approval successfully`);
      dispatch(
        fetchPendingApprovalRequest({
          countryId: countryId,
          status: ["PENDING"],
        })
      );
      navigate(APP_ROUTES.POS_LIST);
    } else {
      setLoading(false);
      let errorMessage = "Error Occurred";
      if (payload?.message !== "No message available") {
        errorMessage = payload.message;
      }
      CustomAlert(ALERT_TYPES.ERROR, errorMessage);
    }
  };

  const send_request_for_approval = () => {
    setLoading(true);
    if (!isEmptyOrNull(dateObject?.activationDate)) {
      const pay_load_object = _validate_send_for_approval_form(originalConfigTab, configTab, dateObject, countryId, stateObj);
      if (isNonEmptyObject(pay_load_object)) {
        call_send_for_approval(pay_load_object);
      } else {
        setLoading(false);
      }
    } else {
      CustomAlert(ALERT_TYPES.ERROR, "Please provide implementation date.");
      setLoading(false);
    }
  };

  const handleIndividualSlotTimeChange = (generatorFormIndex: any, slot_index: any, selectedD_date: any, input_name: any) => {
    if (!isEmptyOrNull(selectedD_date) && !isEmptyOrNull(input_name)) {
      let new_config_tab = updateD_handle_individual_slot_field_change(configTab, generatorFormIndex, slot_index, input_name, selectedD_date);
      setConfigTab(new_config_tab);
    }
  };

  const addNewTemplateSlot = (generatorFormIndex: any, days: any) => {
    if (!isEmptyOrNull(generatorFormIndex) && generatorFormIndex >= 0) {
      if (!isEmptyOrNull(configTab?.zoneId)) {
        let new_config_tab = add_new_template_slot_util(configTab, generatorFormIndex, configTab.zoneId, days, posDetails);
        setConfigTab(new_config_tab);
      } else {
        CustomAlert(ALERT_TYPES.ERROR, "Internal error : No Zone Id found.");
      }
    }
  };

  const deleteTemplateSlot = (generatorFormIndex: any, slot_index: any) => {
    if (!isEmptyOrNull(generatorFormIndex) && generatorFormIndex >= 0 && !isEmptyOrNull(slot_index) && slot_index >= 0) {
      let new_config_tab = delete_template_slot_util(configTab, generatorFormIndex, slot_index);
      setConfigTab(new_config_tab);
    }
  };

  const handleBulkUpdateAction = (generatorFormIndex: any) => {
    if (isEmptyOrNull(generatorFormIndex) || generatorFormIndex < 0) {
      return;
    }

    const is_all_slots_valid = validate_generator_form_before_bulk_update(configTab);
    if (is_all_slots_valid !== true) {
      return;
    }

    const slotsGeneratorForms = configTab?.slotsGeneratorForms;
    const selectedGeneratorForm = slotsGeneratorForms?.[generatorFormIndex];
    const selectedGeneratedSlots = selectedGeneratorForm?.generatedSlots;

    if (!slotsGeneratorForms || !Array.isArray(slotsGeneratorForms) || slotsGeneratorForms.length === 0) {
      return;
    }

    if (isEmptyOrNull(generatorFormIndex) || generatorFormIndex < 0) {
      return;
    }

    if (isEmptyOrNull(selectedGeneratedSlots)) {
      return;
    }

    const isSlotValid = check_if_slot_obj_contains_sub_set(selectedGeneratedSlots);
    if (isNonEmptyObject(isSlotValid)) {
      CustomAlert(ALERT_TYPES.ERROR, isSlotValid[Object.keys(isSlotValid)[0]]);
      return;
    }

    const currentDay = selectedGeneratorForm.days?.[0];
    const allDays: any = slotsGeneratorForms.flatMap(form =>
      isArrayValid(form?.days) && form.days[0] !== currentDay
        ? form.days
        : []
    );

    const generatedForm = { ...selectedGeneratorForm };
    generatedForm.generatedSlots = selectedGeneratedSlots.filter(
      (slot: any) => !isEmptyOrNull(slot?.slotAction) && slot?.slotAction !== "DELETE"
    );

    setStateObj({
      ...stateObj,
      loading: true,
      openBulkUpdateConfirmationPopUp: true,
      generatorFormIndex: generatorFormIndex,
      configuredDays: allDays,
      currentBulkUpdateConfigurationSummary: { ...generatedForm },
      selctedDays: [],
      currentDay: currentDay,
      configurationBulkUpdatedObj: {
        isConfigurationBulkUpdated: false,
        bulkUpdatedDays: [],
      },
    });
  };

  const handleCloseBulkUpdateConfimationPopUp = () => {
    setStateObj({
      ...stateObj,
      loading: false,
      openBulkUpdateConfirmationPopUp: false,
      generatorFormIndex: "",
      configuredDays: [],
      currentBulkUpdateConfigurationSummary: {},
      selctedDays: [],
      currentDay: "",
      configurationBulkUpdatedObj: {
        isConfigurationBulkUpdated: false,
        bulkUpdatedDays: [],
      },
    });
  };

  const clearBulkUpdatedConfimationPopUpObj = (days: any) => {
    setStateObj({
      ...stateObj,
      loading: false,
      openBulkUpdateConfirmationPopUp: false,
      generatorFormIndex: "",
      configuredDays: [],
      currentBulkUpdateConfigurationSummary: {},
      selctedDays: [],
      currentDay: "",
      configurationBulkUpdatedObj: {
        isConfigurationBulkUpdated: true,
        bulkUpdatedDays: [...days],
      },
    });
  };

  const updateStandardServiceStateSelctedDays = (selectedDaysCopy: any) => {
    setStateObj({
      ...stateObj,
      selctedDays: selectedDaysCopy,
    });
  };

  const handleDaySelectedForBulkUpdate = (dayValue: any) => {
    if (isEmptyOrNull(dayValue)) {
      return;
    }

    const selectedDaysCopy: any = [...stateObj.selctedDays];
    if (isArrayValid(selectedDaysCopy)) {
      if (dayValue === TEXT_CONSTANT.ALL) {
        if (selectedDaysCopy.length === stateObj.configuredDays.length) {
          updateStandardServiceStateSelctedDays([]);
        } else {
          updateStandardServiceStateSelctedDays([...stateObj.configuredDays]);
        }
      } else {
        const isElementPresent = selectedDaysCopy.indexOf(dayValue);
        if (isElementPresent > -1) {
          selectedDaysCopy.splice(isElementPresent, 1);
        } else {
          selectedDaysCopy.push(dayValue);
        }
        updateStandardServiceStateSelctedDays(selectedDaysCopy);
      }
    }
  };

  const handleBulkUpdateConfirmAction = () => {
    if (isArrayValid(stateObj?.selctedDays)) {
      const slotsGeneratorForms = configTab?.slotsGeneratorForms;
      const selectedFormIndex = stateObj?.generatorFormIndex;
      const currentSummary = stateObj?.currentBulkUpdateConfigurationSummary;

      if (isArrayValid(slotsGeneratorForms) && !isEmptyOrNull(selectedFormIndex) && !isEmptyOrNull(slotsGeneratorForms[selectedFormIndex]) && isNonEmptyObject(currentSummary)) {
        const slotForm = JSON.parse(JSON.stringify(currentSummary));
        if (isArrayValid(slotForm?.generatedSlots)) {
          let new_config_tab = bulk_update_slot_changes_util(configTab, stateObj.currentDay, stateObj.selctedDays, slotForm);
          setConfigTab(new_config_tab);
          clearBulkUpdatedConfimationPopUpObj(stateObj.selctedDays);
        }
      }
    } else {
      CustomAlert(ALERT_TYPES.ERROR, TEXT_CONSTANT.BULK_UPDATE_NO_DAYS_SELECTED);
    }
  };

  const resetCurrentConfigurationAfterBulkUpdateRevert = () => {
    if (isArrayValid(standard)) {
      designStandardConfigurationsHandler(standard);
    }
  };

  useEffect(() => {
    // Refetch whenever the URL POS differs from the cached posDetails, so a stale
    // POS (from a prior editor visit) can never leak its posId/serviceTypeMappingId
    // into this POS's write payload (DOS-3285).
    if (posNo && String(posDetails?.posNo) !== String(posNo) && serviceTypes.length) {
      dispatch(fetchPOSDetailsByPOSNo(posNo)); //posDetails object
    }
  }, [dispatch, posNo, serviceTypeId, serviceTypeName, posDetails.posNo, serviceTypes.length]);

  useEffect(() => {
    const fetchSlots = () => {
      dispatch(fetchSlotsInformationByServiceType({ posNo, serviceType: serviceTypeId, serviceTypeName })); // fetchingSlots, standard object
      setLoading(false);
    };

    if (posNo && serviceTypeId) {
      fetchSlots();
    }
  }, [dispatch, posNo, serviceTypeId, serviceTypeName]);

  /**
   * Empty redux state on unmount
   */
  useEffect(() => {
    return () => {
      dispatch(resetSlotsInformation());
    };
  }, [dispatch]);

  /**
   * Fetch all the config information once and set it in the configTabs state on every crud operation update
   */
  useEffect(() => {
    if (isArrayValid(standard) && !loading) {
      designStandardConfigurationsHandler(standard);

      // Approval Flow, Show pending record in the side menu
      dispatch(
        fetchPendingApprovalRequest({
          countryId: countryId,
          status: ["PENDING"],
        })
      );
    }
  }, [standard]);

  return (
    <>
      <Grid container spacing={0} className={classes.mainContentSection}>
        <OverlayLoader loading={fetchingDetails || fetchingPosDetails || fetchingSlots || loading || stateObj.loading} />
        {/* Title */}
        <Grid item xs={12} className={classes.titleSectionDiv}>
          <PageTitle title={`Request Approval for Standard POS - ${posNo} - ${configTab.zoneName || ""} `} />
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography className={classes.dateSearchTitleSpanStyle}>{`Implemantation time for changes`}</Typography>
                  </Grid>
                </Grid>
              </Grid>

              {!isEmptyOrNull(dateObject?.activationDatelabel) && dateObject.isDateValid && (
                <Grid item xs={12} className={classes.titleSectionDiv}>
                  {!isEmptyOrNull(configTab?.zoneId) && isArrayValid(configTab?.slotsGeneratorForms) && (
                    <RenderConfigurationSlotsAccordion
                      classes={classes}
                      configTab={configTab}
                      handleIndividualSlotFieldsChange={handleIndividualSlotFieldsChange}
                      makeSlotEditable={makeSlotEditable}
                      handleIndividualSlotTimeChange={handleIndividualSlotTimeChange}
                      deleteTemplateSlot={deleteTemplateSlot}
                      addNewTemplateSlot={addNewTemplateSlot}
                      handleBulkUpdateAction={handleBulkUpdateAction}
                      bulkUpdatedDays={stateObj.configurationBulkUpdatedObj.bulkUpdatedDays}
                      resetCurrentConfigurationAfterBulkUpdateRevert={resetCurrentConfigurationAfterBulkUpdateRevert}
                    />
                  )}
                </Grid>
              )}

              {!isEmptyOrNull(dateObject?.data_present_obj?.requestId) && (
                <Card className={classes.errorCardStyle}>
                  <CardContent>
                    <Typography className={classes.errorTextSpanStyle}>
                      {`A request ${dateObject.data_present_obj.requestId} is already raised for this implementation date by ${dateObject?.data_present_obj?.requester ?? "Admin"}. Please request action on the same.`}
                    </Typography>
                  </CardContent>
                </Card>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Footer */}
        <RenderFooterButtons classes={classes} serviceData={standard} navigate={navigate} posDetails={posDetails} send_request_for_approval={send_request_for_approval} dateObject={dateObject} />
      </Grid>
      <BulkUpdateSummaryDetailsAndConfirmationPopUp
        popUpOpenFlag={stateObj.openBulkUpdateConfirmationPopUp}
        currentConfiguration={stateObj.currentBulkUpdateConfigurationSummary}
        configuredDays={stateObj.configuredDays}
        selctedDays={stateObj.selctedDays}
        currentDay={stateObj.currentDay}
        handleClose={handleCloseBulkUpdateConfimationPopUp}
        handleDaySelectedForBulkUpdate={handleDaySelectedForBulkUpdate}
        handleBulkUpdateConfirmAction={handleBulkUpdateConfirmAction}
      />
    </>
  );
};

export default React.memo(NewStandardRequest);
